export default __webpack_public_path__ + "static/media/DJI_0941.MP4.00_01_18_10.Still001.64f120b7.jpg";